/**
 * An axis title — the unit an axis is in, as opposed to a tick's value. Shared by every SVG
 * template so both axes are titled the same way at both view sizes: centred on the axis, muted,
 * and (for the y axis) rotated into the left gutter that `AXIS.padL` reserves for it.
 */

import { AXIS_LABEL } from "./axis";

interface AxisTitleProps {
  text: string;
  /** Centre of the title, in the chart's pixel space. */
  x: number;
  y: number;
  fontSize: number;
  /** Rotate a quarter turn anticlockwise — how a y-axis title is written. */
  rotate?: boolean;
}

export function AxisTitle({ text, x, y, fontSize, rotate = false }: AxisTitleProps) {
  return (
    <text
      x={x}
      y={y}
      fontSize={fontSize}
      textAnchor="middle"
      fill={AXIS_LABEL}
      transform={rotate ? `rotate(-90 ${x} ${y})` : undefined}
    >
      {text}
    </text>
  );
}
